import React from "react";
import { connect } from "react-redux";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { RightOutlined } from "@ant-design/icons";

import UniFilter from "components/course-areas/UniFilter";
import AreaFilter from "components/course-areas/AreaFilter";
import NavigationFooter from "components/footers/NavigationFooter";
import NoResults from "components/course-areas/NoResults";
import { isPopulated, getCategory } from "utils/helpers";
import FilteredCourses from "components/course-areas/FilteredCourses";
import MasterButton, {
  BUTTON_TYPES,
  BackButton,
} from "components/ui/MasterButton";
import UniFilterMobile from "./UniFilterMobile";
import AreaFilterMobile from "./AreaFilterMobile";
import { ACTION_TYPE } from "reducers/actionType";
import "styles/CourseAreas.scss";
import IconSearch from "assets/Icon-Search.svg";
import FilterAdjustIcon from "assets/filter-adjust.svg";

let state = {
  wordFilter: "",
  uniFilter: [],
  areaFilter: [],
  search: "",
  mobileUniFilter: [],
  mobileAreaFilter: [],
  focus: false,
  filter: false,
};

class CourseAreas extends React.Component {
  constructor(props) {
    super(props);
    this.state = state;
  }

  componentDidMount = () => {
    window.scrollTo(0, -100);
  };

  componentWillUnmount = () => {
    state = this.state;
  };

  toggleFilter = () => {
    const { filter, areaFilter, uniFilter } = this.state;
    this.setState({
      filter: !filter,
      mobileAreaFilter: areaFilter,
      mobileUniFilter: uniFilter,
    });
  };

  clearFilters = () =>
    this.setState({
      uniFilter: [],
      areaFilter: [],
      wordFilter: "",
      search: "",
    });

  handleSearchChange = (e) => {
    const { value } = e.target;
    this.setState({ search: value });
    if (value.length === 0) {
      this.setState({ wordFilter: "" });
    }
  };
  handleSearch = () => {
    this.setState({ wordFilter: this.state.search });
  };

  handleUniFilterChange = (selectedValues) =>
    this.setState({ uniFilter: selectedValues });
  handleAreaFilterChange = (selectedValues) =>
    this.setState({ areaFilter: selectedValues });

  // MOBILE TYLES
  handleMobileUniFilterChange = (selectedValues) =>
    this.setState({ mobileUniFilter: selectedValues });
  handleMobileAreaFilterChange = (selectedValues) =>
    this.setState({ mobileAreaFilter: selectedValues });
  applyMobileFilters = () => {
    const { mobileUniFilter, mobileAreaFilter } = this.state;
    this.setState({
      areaFilter: mobileAreaFilter,
      uniFilter: mobileUniFilter,
      filter: false,
    });
  };
  handleFocus = () => {
    if (navigator.userAgent.match(/Android/i)) {
      this.setState({ focus: true });
    }
  };
  handleBlur = () => {
    if (navigator.userAgent.match(/Android/i)) {
      this.setState({ focus: false });
    }
  };
  clearAll = () => {
    this.props.dispatch({
      type: ACTION_TYPE.COURSE.RESET,
    });
  };

  renderMain = () => {
    const { uniFilter, areaFilter, wordFilter, search } = this.state;
    const { userCourses, input } = this.props;
    const { fields_of_study, institutions } = input;
    const noResults =
      _.isEmpty(uniFilter) && _.isEmpty(areaFilter) && wordFilter.length === 0;
    return (
      <>
        <div className="padding-top padding-sides" />
        <div className="padding-sides course-area-top">
          <div className="flex-space-between">
            <div>
              <h1>Search for the course you’re interested in</h1>
              <p className="desktop-and-tablet">
                Select at least one course to continue
              </p>
            </div>
            {userCourses.length !== 0 && (
              <NavLink
                to="/course-areas/selected-courses"
                className="desktop-and-tablet"
              >
                <MasterButton
                  type={BUTTON_TYPES.TERTIARY}
                  text="Selected Courses"
                  className="desktop-and-tablet"
                />
              </NavLink>
            )}
          </div>
        </div>

        {userCourses.length !== 0 && (
          <div className="mobile-only">
            <NavLink
              to="/course-areas/selected-courses"
              name="/course-areas/selected-courses"
            >
              <div className="course-area-selected-courses-block">
                <div>Selected courses</div> <RightOutlined />
              </div>
            </NavLink>
          </div>
        )}
        <div className="course-area-search-bar">
          <div className="flex-align-items-center" style={{ width: "100%" }}>
            <img
              className="course-area-search-bar-icon"
              src={IconSearch}
              alt="Search bar"
              width="22px"
              style={{ marginRight: 10 }}
            />
            <Input
              aria-label="Search Course Name"
              value={search}
              placeholder="Search Course Name"
              onChange={this.handleSearchChange}
              onPressEnter={this.handleSearch}
              className="course-area-search-bar"
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            />
          </div>
        </div>

        <div className="mobile-only padding-bottom">
          <MasterButton
            type={BUTTON_TYPES.CLEAR}
            text="Filter search"
            callback={this.toggleFilter}
            wide={true}
            style={{ width: "calc(100% - 20px)", margin: 10 }}
          />
        </div>

        <div className="course-area-filter-bar desktop-and-tablet">
          <img
            src={FilterAdjustIcon}
            alt="adjust filters"
            width="23px"
            style={{ marginRight: 4 }}
          />
          <span style={{ fontSize: 16 }}>Filter by</span>
          <UniFilter
            selected={uniFilter}
            institutions={institutions}
            onChange={this.handleUniFilterChange}
          />
          <AreaFilter
            selected={areaFilter}
            fieldsOfStudy={fields_of_study}
            onChange={this.handleAreaFilterChange}
          />
          <MasterButton
            type={BUTTON_TYPES.CLEAR}
            text="Clear filters"
            callback={this.clearFilters}
          />
        </div>

        {noResults ? null : (
          <p
            className="mobile-only padding-sides"
            style={{ fontSize: 16, margin: "10px 0px" }}
          >
            Select at least one course to continue
          </p>
        )}

        {noResults ? (
          <NoResults />
        ) : (
          <FilteredCourses
            uniFilter={uniFilter}
            areaFilter={areaFilter}
            wordFilter={wordFilter}
          />
        )}
      </>
    );
  };

  renderFilters = () => {
    const { mobileAreaFilter, mobileUniFilter, areaFilter, uniFilter } =
      this.state;
    const { input } = this.props;
    const { fields_of_study, institutions } = input;
    return (
      <>
        <div className="padding-top padding-sides">
          <BackButton onClick={this.toggleFilter} />
          <div style={{ fontSize: 16, marginBottom: 10 }}>Filter by</div>
        </div>
        <UniFilterMobile
          uniFilter={uniFilter}
          selected={mobileUniFilter}
          institutions={institutions}
          onChange={this.handleMobileUniFilterChange}
        />
        <AreaFilterMobile
          areaFilter={areaFilter}
          selected={mobileAreaFilter}
          fieldsOfStudy={fields_of_study}
          onChange={this.handleMobileAreaFilterChange}
        />

        <MasterButton
          type={BUTTON_TYPES.CLEAR}
          text="Apply changes"
          style={{ width: "calc(100% - 20px)", margin: "10px 10px" }}
          callback={this.applyMobileFilters}
        />
        <MasterButton
          type={BUTTON_TYPES.CLEAR}
          text="Clear changes"
          style={{ width: "calc(100% - 20px)", margin: "10px 10px" }}
          callback={this.clearFilters}
        />
      </>
    );
  };

  render() {
    const { filter, focus } = this.state;
    return (
      <>
        {filter ? this.renderFilters() : this.renderMain()}
        <NavigationFooter
          focus={focus}
          enable={isPopulated(getCategory("CourseAreas"))}
          nextNavlink="studies"
          final={true}
          onSkip={this.clearAll}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  const { userCourses } = store.coursesReducer;
  const { input } = store.inputReducer;
  return { userCourses, input };
};

export default connect(mapStateToProps)(CourseAreas);
